<template>
  <div class="block">
    <div class="categories-list categories-list--layout--columns-5-sidebar">
      <ul class="categories-list__body">
        <category-drill-item 
        v-for="category in getCategoryItems"
        :key="category.ID"
        :category="category"
        ></category-drill-item>
      </ul>
    </div>
  </div>
  <base-spinner :open="isloading"></base-spinner>
</template>

<script>
import CategoryDrillItem from './CategoryDrillItem.vue';

export default {
    components: {
        CategoryDrillItem
    },
    data() {
        return {
            categories : [],
            isloading  : false,
        }
    },

    created() {
        
    },
    computed: {
        getCategoryItems() {
            let category_level = [];
            const categories = this.$store.getters['product/categories'];
            const level = this.$route.params.level;
            const code1 = this.$route.params.categoryUri1;
            const code2 = this.$route.params.categoryUri2;
            const code3 = this.$route.params.categoryUri3;
            const code4 = this.$route.params.categoryUri4;
            const code5 = this.$route.params.categoryUri5;
            const code6 = this.$route.params.categoryUri6;
            const code7 = this.$route.params.categoryUri7;
            const code8 = this.$route.params.categoryUri8;
            const code9 = this.$route.params.categoryUri9;
            
            if(level == 1){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.categorylevel === 2)));
            }else if(level == 2){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.categorylevel === 3)));
            }else if(level == 3){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.categorylevel === 4)));
            }else if(level == 4){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.categorylevel === 5)));
            }else if(level == 5){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.DMCD05 === code5) && (cat.categorylevel === 6)));
            }else if(level == 6){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.DMCD05 === code5) && (cat.DMCD06 === code6) && (cat.categorylevel === 7)));
            }else if(level == 7){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.DMCD05 === code5) && (cat.DMCD06 === code6) && (cat.DMCD07 === code7) && (cat.categorylevel === 8)));
            }else if(level == 8){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.DMCD05 === code5) && (cat.DMCD06 === code6) && (cat.DMCD07 === code7) && (cat.DMCD08 === code8) && (cat.categorylevel === 9)));
            }else if(level == 9){
                category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.DMCD03 === code3) && (cat.DMCD04 === code4) && (cat.DMCD05 === code5) && (cat.DMCD06 === code6) && (cat.DMCD07 === code7) && (cat.DMCD08 === code8) && (cat.DMCD09 === code9) && (cat.categorylevel === 10)));
            }

            category_level.sort((a,b) => (a.categoryname > b.categoryname) ? 1 : ((b.categoryname > a.categoryname) ? -1 : 0));

            // this.isloading = true;
            // console.table(category_level);
            return category_level;
        }
    },

    beforeUpdate() {
        // this.isloading = true;
        // setTimeout(() => {
        //     console.log('dropped');
        //     this.isloading = false;
        // }, 500);
    },

    updated() {
        // this.isloading = false;
    },

    methods: {
        
        // getCategoryItems() {
        //     const level = this.$route.params.level;
        //     console.log(level);
        //     // const category_level = this.store.getters('product/category_by_level', level);
        //     const categories = this.$store.getters['product/categories'];
        //     const category_level = categories.filter((lvl) => lvl.categorylevel === level);
        //     console.log(category_level);
        // }
    }
}
</script>